import { createSlice } from "@reduxjs/toolkit";


type ModalSlice = {
    
    AddSubOpen: boolean;
    AddBankAccountOpen: boolean;
    isLoading: boolean;
    ViewAccountDetails: boolean;
    EditSubscriptionModalOpen: boolean;
    AddLiveSubscriptionModalOpen: boolean;
    RaiseInvoiceModalOpen: boolean;
    EditLiveSubscriptionModalOpen: boolean;
    OrderMarkPaidConfirmModalOpen: boolean;
    PauseLiveSubscriptionModalOpen: boolean;
    TerminateLiveSubscriptionModalOpen: boolean;
    OrderSummaryModalOpen: boolean;
    RemindPaymentWhatsappModalOpen: boolean;
    editServiceProviderModalOpen: boolean;
    CustomBrandingModalOpen: boolean;
    EditCustomBrandingModalOpen: boolean;
    AllBankAccountsModalOpen: boolean;
    WhatsappUnblockNotificationOpen: boolean;
    FetchExistingSubscribersModalOpen: boolean;
    QRCodeModalOpen: boolean;
    BuyCreditsModalOpen: boolean;
    ComingSoonModalOpen: boolean;
    DeleteLiveSubscriptionModalOpen: boolean;
    PauseErrorModalOpen: boolean;
    ResumeLiveSubscriptionModalOpen: boolean;
    AddOfferModalOpen: boolean;
    AddEventsModalOpen: boolean;
    EditOfferModalOpen: boolean;
    ExportPaymentsModalOpen: boolean;
    ExportAttendanceModalOpen: boolean;
    ExportStudentProgressModalOpen: boolean;
    ExportDataModalOpen:boolean // New state
    TeamManagementModalOpen: boolean; // New state
    AddTeamMemberModalOpen: boolean; // New state
    RevokeRoleModalOpen: boolean; // New state
    EditEventsModalOpen:boolean;
    QREventsandOfferModalOpen: boolean;
    MultiMonthPauseModalOpen:boolean;
    MultiMonthResumeModalOpen:boolean;
    CancelPauseModalOpen:boolean;
    MMEditOrderModalOpen:boolean;
    AddEventCustomFieldsModalOpen:boolean;
    EditEventCustomFieldModalOpen:boolean;
    DeleteAdditionalFormFieldsModalOpen:boolean;
    SingleRaiseInvoiceModalOpen:boolean;
    BulkRaiseInvoiceModalOpen:boolean; 
    BulkRemindersModalOpen:boolean;
    RoleSwitchModalOpen: boolean; // Added for role switching
    // Money Trail modals
    PaymentRequestModalOpen: boolean;
    RecordManualPaymentModalOpen: boolean;
    RecordExpenseModalOpen: boolean;
    PaymentHeadersModalOpen: boolean;
    // Inflow modals
    AddLeadModalOpen: boolean;
    EditLeadModalOpen: boolean;
    CustomPlanPriceModalOpen:boolean;
    QuickCollectModalOpen:boolean;
    EditorJSModalOpen: boolean;
    // Custom Boards (Inflow) modals
    AddBoardModalOpen: boolean;
    AddColumnModalOpen: boolean;
    AddItemModalOpen: boolean;
    CreateFollowupModalOpen: boolean;
    // Customer KYC modals
    CustomerKYCModalOpen: boolean;
    AddCustomerKYCFieldModalOpen: boolean;
    EditCustomerKYCFieldModalOpen: boolean;
    DeleteCustomerKYCFieldModalOpen: boolean;
    // Move Student modal
    MoveStudentModalOpen: boolean;
    // Delete Batch modal
    DeleteBatchModalOpen: boolean;
}

const initialState: ModalSlice = {
    AddSubOpen: false,
    AddBankAccountOpen: false,
    isLoading: false,
    ViewAccountDetails: false,
    EditSubscriptionModalOpen: false,
    AddLiveSubscriptionModalOpen: false,
    RaiseInvoiceModalOpen: false,
    EditLiveSubscriptionModalOpen: false,
    OrderMarkPaidConfirmModalOpen: false,
    PauseLiveSubscriptionModalOpen: false,
    TerminateLiveSubscriptionModalOpen: false,
    OrderSummaryModalOpen: false,
    RemindPaymentWhatsappModalOpen: false,
    editServiceProviderModalOpen: false,
    CustomBrandingModalOpen: false,
    EditCustomBrandingModalOpen: false,
    AllBankAccountsModalOpen: false,
    WhatsappUnblockNotificationOpen: false,
    FetchExistingSubscribersModalOpen: false,
    QRCodeModalOpen: false,
    QREventsandOfferModalOpen: false,
    BuyCreditsModalOpen: false,
    ComingSoonModalOpen: false,
    DeleteLiveSubscriptionModalOpen: false,
    PauseErrorModalOpen: false,
    ResumeLiveSubscriptionModalOpen: false,
    AddOfferModalOpen: false,
    AddEventsModalOpen: false,
    EditOfferModalOpen: false,
    ExportAttendanceModalOpen: false,
    ExportPaymentsModalOpen: false,
    ExportStudentProgressModalOpen: false,
    TeamManagementModalOpen: false,
    AddTeamMemberModalOpen: false,
    RevokeRoleModalOpen: false,
    EditEventsModalOpen:false,
    MultiMonthPauseModalOpen:false,
    MultiMonthResumeModalOpen:false,
    CancelPauseModalOpen:false,
    MMEditOrderModalOpen:false,
    AddEventCustomFieldsModalOpen:false,
    EditEventCustomFieldModalOpen:false,
    DeleteAdditionalFormFieldsModalOpen:false,
    SingleRaiseInvoiceModalOpen:false,
    ExportDataModalOpen:false,
    BulkRaiseInvoiceModalOpen:false,
    BulkRemindersModalOpen:false,
    RoleSwitchModalOpen: false, // Added for role switching
    CustomPlanPriceModalOpen:false,
    // Money Trail modals
    PaymentRequestModalOpen: false,
    RecordManualPaymentModalOpen: false,
    RecordExpenseModalOpen: false,
    PaymentHeadersModalOpen: false,
    // Inflow modals
    AddLeadModalOpen: false,
    EditLeadModalOpen: false,
    QuickCollectModalOpen:false,
    EditorJSModalOpen: false
    ,
    // Custom Boards (Inflow)
    AddBoardModalOpen: false,
    AddColumnModalOpen: false,
    AddItemModalOpen: false,
    CreateFollowupModalOpen: false,
    // Customer KYC modals
    CustomerKYCModalOpen: false,
    AddCustomerKYCFieldModalOpen: false,
    EditCustomerKYCFieldModalOpen: false,
    DeleteCustomerKYCFieldModalOpen: false,
    MoveStudentModalOpen: false,
    DeleteBatchModalOpen: false
}

type currentModal =
    "AddSubOpen"
    | "AddBankAccountOpen"
    | "ViewAccountDetails"
    | "EditSubscriptionModalOpen"
    | "AddLiveSubscriptionModalOpen"
    | "RaiseInvoiceModalOpen"
    | "EditLiveSubscriptionModalOpen"
    | "OrderMarkPaidConfirmModalOpen"
    | "PauseLiveSubscriptionModalOpen"
    | "OrderSummaryModalOpen"
    | "RemindPaymentWhatsappModalOpen"
    | "editServiceProviderModalOpen"
    | "CustomBrandingModalOpen"
    | "AllBankAccountsModalOpen"
    | "WhatsappUnblockNotificationOpen" 
    | "EditCustomBrandingModalOpen" 
    | "FetchExistingSubscribersModalOpen" 
    | "QRCodeModalOpen" 
    | "QREventsandOfferModalOpen" 
    | "DeleteLiveSubscriptionModalOpen" 
    | "PauseErrorModalOpen" 
    | "ResumeLiveSubscriptionModalOpen"
    | "AddOfferModalOpen" 
    | "AddEventsModalOpen"
    | "EditEventsModalOpen"
    | "EditOfferModalOpen"
    | "ExportPaymentsModalOpen" 
    | "ExportAttendanceModalOpen"
    | "ExportStudentProgressModalOpen"
    | "TeamManagementModalOpen" 
    | "AddTeamMemberModalOpen" 
    | "RevokeRoleModalOpen" 
    | "MultiMonthPauseModalOpen" 
    | "MultiMonthResumeModalOpen" 
    | "CancelPauseModalOpen" 
    | "MMEditOrderModalOpen" 
    | "AddEventCustomFieldsModalOpen" 
    | "EditEventCustomFieldModalOpen" 
    | "DeleteAdditionalFormFieldsModalOpen" 
    | "SingleRaiseInvoiceModalOpen" 
    | "BulkRaiseInvoiceModalOpen" 
    
    | "BulkRemindersModalOpen"
    | "RoleSwitchModalOpen" // Added for role switching
    // Money Trail modals
    | "PaymentRequestModalOpen"
    | "RecordManualPaymentModalOpen"
    | "RecordExpenseModalOpen"
    | "PaymentHeadersModalOpen"
    | "AddLeadModalOpen"
    | "EditLeadModalOpen"
    | "CustomPlanPriceModalOpen" | "QuickCollectModalOpen" | "EditorJSModalOpen"
    | "AddBoardModalOpen" | "AddColumnModalOpen" | "AddItemModalOpen" | "CreateFollowupModalOpen"
    | "CustomerKYCModalOpen" | "AddCustomerKYCFieldModalOpen" | "EditCustomerKYCFieldModalOpen" | "DeleteCustomerKYCFieldModalOpen"
    | "MoveStudentModalOpen"
    | "DeleteBatchModalOpen"

    // eslint-disable-next-line react-refresh/only-export-components
const ModalSlice = createSlice({
    name: "ModalSlice",
    initialState,
    reducers: {
        openModal: (state, action) => {
            state[action.payload as currentModal] = true;
        },
        closeModal: (state, action) => {
            state[action.payload as currentModal] = false;
        },
        toggleLoading: (state, action) => {
            state.isLoading = action.payload
        }
    }
})

export const { openModal, closeModal, toggleLoading } = ModalSlice.actions;
export default ModalSlice.reducer;